import { useStorage, type MaybeRefOrGetter } from '@vueuse/core'

export function useLocalStorage<T>(key: string, defaults: MaybeRefOrGetter<T>) {
  try {
    return useStorage<T>(key, defaults, localStorage, {
      serializer: {
        read: (v: any) => (v ? JSON.parse(v) : defaults),
        write: (v: any) => JSON.stringify(v)
      }
    })
  } catch (error) {
    throw new Error(`Error initializing localStorage: ${error}`)
  }
}
